var exports = {
  "kL": "PiPOverlay.module__container___YlM3OS",
  "$I": "PiPOverlay.module__containerResizing___YlM3OS",
  "n_": "PiPOverlay.module__hoverOverlay___YlM3OS",
  "YQ": "PiPOverlay.module__containerInteractionActive___YlM3OS",
  "YL": "PiPOverlay.module__headerGradient___YlM3OS",
  "VW": "PiPOverlay.module__headerContent___YlM3OS",
  "LD": "PiPOverlay.module__headerLeft___YlM3OS",
  "q3": "PiPOverlay.module__returnToCallButton___YlM3OS",
  "fs": "PiPOverlay.module__returnToCallIcon___YlM3OS",
  "Qt": "PiPOverlay.module__returnToCallLabel___YlM3OS",
  "wY": "PiPOverlay.module__footerGradient___YlM3OS",
  "z8": "PiPOverlay.module__footerContent___YlM3OS",
  "PU": "PiPOverlay.module__footerLeft___YlM3OS",
  "zz": "PiPOverlay.module__streamerName___YlM3OS",
  "wV": "PiPOverlay.module__footerRight___YlM3OS",
  "ti": "PiPOverlay.module__spectatorBadge___YlM3OS",
  "Bh": "PiPOverlay.module__spectatorIcon___YlM3OS",
  "hP": "PiPOverlay.module__actionButton___YlM3OS",
  "P4": "PiPOverlay.module__disconnectButton___YlM3OS",
  "gE": "PiPOverlay.module__actionIcon___YlM3OS",
};

module.exports = exports;
